<div class="title-header">
  <div nxLayout="grid maxwidth">
    <div nxRow>
      <div nxCol="12">
        <h1 class="page_font_weight">{{ productName?.descp ?? "MOTOR" | titlecase }}</h1>
      </div>
    </div>
  </div>
</div>

<div nxLayout="grid maxwidth">
  <div nxRow>
    <div nxCol="12,12,12,3" class="grid_width_page">
      <steps [steps]="selectedStepperList" [currentStep]="getCurrentStep" [index]="getCurrentStep"></steps>
    </div>
    <div nxCol="12,12,12,9" class="grid_width_page">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (isShowCrossSell && crossSellList.length !== 0) {
  <!-- <div nxLayout="grid nopadding"> -->
    <!-- <div nxRow> -->
      <!-- <div nxCol="12"> -->
        <!--cross sell banner-->
        <app-cross-sell-banner [crossSellList]="crossSellList" [userInfo]="userInfo" [marketingConsent]="marketingConsent" [clientPartnerInfo]="customerPartnerInfo" [agentInfo]="agentInfo"> </app-cross-sell-banner>
      <!-- </div> -->
    <!-- </div> -->
  <!-- </div> -->
}
